import { jobOrderColNm } from "constants/jobOrderConstant"
import { shipmentColNm } from "constants/shipmentConstant"
const defaultDailyTableColWidth =  [
  {
    field: "No",
    headerName: "No.",
    width: 60,
    visible: true,
    order: 1,
    colClr: null,
  },
  {
    field: "DXAmnt",
    headerName: jobOrderColNm.DXAmnt,
    width: 120,
    visible: true,
    order: 2,
    colClr: null,
  },
  {
    field: "DXNName",
    headerName: jobOrderColNm.DXNName,
    width: 120,
    visible: true,
    order: 2.1,
    colClr: null,
  },
  {
    field: "JobNo",
    headerName: jobOrderColNm.JobNo,
    width: 120,
    visible: true,
    order: 1,
    colClr: "whitesmoke-column-color",
  },
  {
    field: "JobOrdId",
    headerName: jobOrderColNm.JobOrdId,
    width: 100,
    visible: true,
    order: 3,
    colClr: null,
  },
  {
    field: "ShpmTypAbbr",
    headerName: jobOrderColNm.ShpmTypAbbr,
    width: 100,
    visible: true,
    order: 3,
    colClr: null,
  },
  {
    field: "AptTm",
    headerName: "เวลานัด",
    width: 100,
    visible: true,
    order: 4,
    colClr: "Azure-column-color",
  },
  {
    field: "IsRdyTake",
    headerName: "สถานะ",
    width: 70,
    visible: true,
    order: 5,
    colClr: null,
  },
  {
    field: "ContSizeFull",
    headerName: jobOrderColNm.ContSize,
    width: 80,
    visible: true,
    order: 6,
    colClr: "whitesmoke-column-color",
  },
  {
    field: "TlrTyp",
    headerName: jobOrderColNm.TlrTyp,
    width: 90,
    visible: true,
    order: 7,
    colClr: "whitesmoke-column-color",
  },
  {
    field: "ContNo",
    headerName: jobOrderColNm.ContNo,
    width: 130,
    visible: true,
    order: 8,
    colClr: null,
  },
  {
    field: "SealNo",
    headerName: "ซีล",
    width: 100,
    visible: true,
    order: 9,
    colClr: null,
  },
  {
    field: "NumFile",
    headerName: "รูปภาพ",
    width: 70,
    visible: true,
    order: 9,
    colClr: null,
  },
  {
    field: "TareWt",
    headerName: jobOrderColNm.TareWt,
    width: 90,
    visible: true,
    order: 10,
    colClr: null,
  },
  {
    field: "FullWt",
    headerName: jobOrderColNm.FullWt,
    width: 90,
    visible: true,
    order: 11,
    colClr: null,
  },
  {
    field: "ISOCd",
    headerName: jobOrderColNm.ISOCd,
    width: 90,
    visible: true,
    order: 12,
    colClr: null,
  },
  {
    field: "TakePlc",
    headerName: jobOrderColNm.TakePlc,
    width: 90,
    visible: true,
    order: 13,
    colClr: null,
  },
  {
    field: "Loc",
    headerName: jobOrderColNm.Loc,
    width: 120,
    visible: true,
    order: 14,
    colClr: null,
  },
  {
    field: "RtnPlc",
    headerName: jobOrderColNm.RtnPlc,
    width: 90,
    visible: true,
    order: 15,
    colClr: null,
  },
  {
    field: "TakeDteSt",
    headerName: jobOrderColNm.TakeDteSt,
    width: 100,
    visible: true,
    order: 16,
    colClr: null,
  },
  {
    field: "TakeDteEn",
    headerName: jobOrderColNm.TakeDteEn,
    width: 100,
    visible: true,
    order: 17,
    colClr: null,
  },
  {
    field: "RtnDteSt",
    headerName: jobOrderColNm.RtnDteSt,
    width: 100,
    visible: true,
    order: 18,
    colClr: null,
  },
  {
    field: "RtnDteEn",
    headerName: jobOrderColNm.RtnDteEn,
    width: 100,
    visible: true,
    order: 19,
    colClr: null,
  },
  {
    field: "ContStses",
    headerName: "พนักงานขับรถ",
    width: 340,
    visible: true,
    order: 20,
    colClr: null,
  },
  
  {
    field: "TakeArvTm",
    headerName: jobOrderColNm.TakeArvTm,
    width: 100,
    visible: true,
    order: 21,
    colClr: null,
  },
  {
    field: "TakeLevTm",
    headerName: jobOrderColNm.TakeLevTm,
    width: 100,
    visible: true,
    order: 21,
    colClr: null,
  },
  {
    field: "RtnArvTm",
    headerName: jobOrderColNm.RtnArvTm,
    width: 100,
    visible: true,
    order: 21,
    colClr: null,
  },
  {
    field: "RtnLevTm",
    headerName: jobOrderColNm.RtnLevTm,
    width: 100,
    visible: true,
    order: 21,
    colClr: null,
  },
  {
    field: "ArvTm",
    headerName: jobOrderColNm.ArvTm,
    width: 100,
    visible: true,
    order: 21,
    colClr: null,
  },
  {
    field: "LevTm",
    headerName: jobOrderColNm.LevTm,
    width: 100,
    visible: true,
    order: 22,
    colClr: null,
  },
  {
    field: "FinDte",
    headerName: jobOrderColNm.FinDte,
    width: 100,
    visible: true,
    order: 23,
    colClr: null,
  },
  {
    field: "Bkg",
    headerName: jobOrderColNm.Bkg,
    width: 120,
    visible: true,
    order: 24,
    colClr: "whitesmoke-column-color",
  },
  {
    field: "Agnt",
    headerName: shipmentColNm.Agnt,
    width: 100,
    visible: true,
    order: 25,
    colClr: "whitesmoke-column-color",
  },
  {
    field: "Vssl",
    headerName: shipmentColNm.Vssl,
    width: 100,
    visible: true,
    order: 26,
    colClr: "whitesmoke-column-color",
  },
  {
    field: "Voy",
    headerName: shipmentColNm.Voy,
    width: 80,
    visible: true,
    order: 27,
    colClr: "whitesmoke-column-color",
  },
  {
    field: "Port",
    headerName: shipmentColNm.Port,
    width: 80,
    visible: true,
    order: 28,
    colClr: "whitesmoke-column-color",
  },
  {
    field: "JobSNm",
    headerName: jobOrderColNm.JobSNm,
    width: 120,
    visible: true,
    order: 29,
    colClr: "whitesmoke-column-color",
  },
  {
    field: "CusSNm",
    headerName: jobOrderColNm.CusSNm,
    width: 120,
    visible: true,
    order: 30,
    colClr: "whitesmoke-column-color",
  },
  {
    field: "PlnTxt",
    headerName: jobOrderColNm.PlnTxt,
    width: 300,
    visible: true,
    order: 31,
    colClr: null,
  },
  {
    field: "Rmk",
    headerName: jobOrderColNm.Rmk,
    width: 300,
    visible: true,
    order: 32,
    colClr: null,
  },
  {
    field: "Memo",
    headerName: jobOrderColNm.Memo,
    width: 300,
    visible: true,
    order: 33,
    colClr: null,
  },
  {
    field: "JoRef1",
    headerName: jobOrderColNm.JoRef1,
    width: 100,
    visible: false,
    order: 34,
    colClr: null,
  },
  {
    field: "JoRef2",
    headerName: jobOrderColNm.JoRef2,
    width: 100,
    visible: false,
    order: 35,
    colClr: null,
  },
  {
    field: "ShRef1",
    headerName: jobOrderColNm.ShRef1,
    width: 100,
    visible: false,
    order: 36,
    colClr: null,
  },
  {
    field: "ShRef2",
    headerName: jobOrderColNm.ShRef2,
    width: 100,
    visible: false,
    order: 37,
    colClr: null,
  },
  {
    field: "TagNm",
    headerName: jobOrderColNm.TagNm,
    width: 100,
    visible: true,
    order: 38,
    colClr: null,
  }
]

export default defaultDailyTableColWidth